import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

import { onMounted, ref, toRefs } from 'vue'
import type {PropType} from 'vue'
import { usePromisifyDialog, getFloatupIndex, isMaxFloatupIndex } from '@shared/utils/dialog'
import { useDownload } from '@remote/composable/download'
import BtChoicePop from './BtChoicePop.vue'
import { ITreedTorrentNode } from '@remote/api/adapter/type'


export default /*#__PURE__*/_defineComponent({
  props: {
  isBt: {
    type: Boolean,
    default: false,
  },
  btTree: {
    type: [Array, Promise] as PropType<ITreedTorrentNode[]|Promise<ITreedTorrentNode[]>>,
    default: function () {
      return []
    },
  },
  linkStatus: {
    type: Object,
    default: function () {
      return {
        ok: 0,
        invalid: 0,
        err: 0,
      }
    },
  },
  url: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  isLimitDownloaded: {
    type: Boolean,
    default: false,
  },
  callback: {
    type: Function,
    default: function () {
      return () => {}
    },
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



const { callback } = toRefs(props)
const isMountedRef = ref(false)
const floatupRef = ref(0)



const { close, zIndex } = usePromisifyDialog(emit)

const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

const handleFloatup = () => {
  if (!isMaxFloatupIndex(floatupRef.value)) {
    floatupRef.value = getFloatupIndex()
  }
}

const handleCallback = () => {
  close(null)
  callback?.value && callback?.value()
}

const { downloadList } = useDownload(handleCallback)

onMounted(async () => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper", { 'is-mounted': isMountedRef.value }]),
      style: _normalizeStyle({ zIndex: Math.max(_unref(zIndex), floatupRef.value) })
    }, [
      (__props.isBt && isMountedRef.value)
        ? (_openBlock(), _createBlock(BtChoicePop, {
            key: 0,
            "bt-tree": __props.btTree,
            "link-status": __props.linkStatus,
            url: __props.url,
            id: __props.id,
            "is-limit-downloaded": __props.isLimitDownloaded,
            onOnClose: _cache[0] || (_cache[0] = ($event: any) => (handleClose())),
            onOnOk: _unref(downloadList),
            onOnFloatup: handleFloatup,
            offset: (Math.min(Math.abs(999 - _unref(zIndex)), 30)) * 10
          }, null, 8, ["bt-tree", "link-status", "url", "id", "is-limit-downloaded", "onOnOk", "offset"]))
        : _createCommentVNode("", true)
    ], 6)
  ]))
}
}

})